import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import UploadDocument from "@/pages/UploadDocument";
import PriceCalculator from "@/pages/PriceCalculator";
import AcademicRequest from "@/pages/AcademicRequest";
import TrackOrder from "@/pages/TrackOrder";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalPage from "@/pages/LegalPage";
import LandingPage from "@/pages/LandingPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import AdminArticles from "@/pages/AdminArticles";
import AdminArticleEdit from "@/pages/AdminArticleEdit";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/upload" element={<UploadDocument />} />
            <Route path="/calculator" element={<PriceCalculator />} />
            <Route path="/academic-request" element={<AcademicRequest />} />
            <Route path="/track" element={<TrackOrder />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/articles" element={<ProtectedRoute adminOnly><AdminArticles /></ProtectedRoute>} />
            <Route path="/admin/articles/:id" element={<ProtectedRoute adminOnly><AdminArticleEdit /></ProtectedRoute>} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/disclaimer" element={<LegalPage kind="disclaimer" />} />
            <Route path="/lp/:slug" element={<LandingRouteWrapper />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

function LandingRouteWrapper() {
  const { slug } = useParams();
  return <LandingPage slug={slug} />;
}
